import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<
      unknown,
      Error,
      { gatewayId: number; contractorId: number | null },
      unknown
    >,
    'mutationKey' | 'mutationFn'
  >
}

export const useAssignGatewayRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { gatewayId: number; contractorId: number | null }, unknown>(
    [Entities.Gateway, 'assign'],
    async ({ gatewayId, contractorId }) => {
      try {
        const { data } = await api.v1AdminGatewaysGatewayIdAssignToContractorPost(gatewayId, {
          data: { contractorId }
        } as any)
        return data
      } catch (e) {
        throw e
      }
    },
    {
      ...options
    }
  )
}
